import React from "react";
import * as T from "prop-types";

import { Field, Inputs } from "2g-form";

import { ZdrojFull } from "b2b/renderers/ciselnik/";
import { ADMIN } from "b2b/api/paths";

import useMessages from "./i18n/useMessages";

export function ACZdroje({ ...props }) {
  const { zdrojLabel, zdrojPlaceholder } = useMessages();
  return (
    <Field
      component={Inputs.AutoComplete}
      url={ADMIN.zdroje()}
      rendererSelected={ZdrojFull}
      rendererOption={ZdrojFull}
      loadOnce
      staticKey={["nazevCs", "nazevEn"]}
      minChars={0}
      label={zdrojLabel()}
      placeholder={zdrojPlaceholder()}
      descriptionRenderer={ZdrojFull}
      {...props}
    />
  );
}

ACZdroje.propTypes = {
  multiple: T.bool
};

export default React.memo(ACZdroje);
